"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tpvTheme = void 0;
var tslib_1 = require("tslib");
var theme_1 = require("./theme");
var darkTeal = '#1E856B';
var lightTeal = 'rgba(208, 244, 235, 0.4)';
exports.tpvTheme = tslib_1.__assign(tslib_1.__assign({}, theme_1.theme), { name: 'tpv', colors: tslib_1.__assign(tslib_1.__assign({}, theme_1.theme.colors), { datePicker: {
            tileDark: darkTeal,
            tileLight: lightTeal,
            apply: darkTeal,
            applyDark: darkTeal,
            applyOutline: lightTeal,
            smartItem: lightTeal,
            smartCheck: darkTeal,
        } }) });
